import { apiSlice } from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => {
        console.log("Login query being called with:", credentials);
        const config = {
          url: "/",
          method: "POST",
          body: { ...credentials },
        };
        console.log("Login query config:", config);
        return config;
      },
    }),
    logout: builder.mutation({
      query: (credentials) => {
        console.log("Logout query being called with:", credentials);
        const config = {
          url: "/logout",
          method: "POST",
          body: { ...credentials },
        };
        console.log("Logout query config:", config);
        return config;
      },
    }),
    refresh: builder.mutation({
      query: () => ({
        url: "/refresh",
        method: "GET",
      }),
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        url: "/change-password",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useRefreshMutation,
  useChangePasswordMutation,
} = authApiSlice;
